export class StringHelper {
    public static format(input: string, values: string[]): string {
        let result: string = input;
        for (let i = 0; i < values.length; i++) {
          result = result.replace(`{${i}}`, values[i]);
        }
        return result;
      }
}
